// Nation coordinates (approximate center points for capitals/major cities)
export const NATION_COORDINATES: { [key: string]: [number, number] } = {
  // Special
  'EU': [50.8503, 4.3517], // Brussels
  'EXCON': [50.8503, 4.3517], // Brussels

  // NATO & Partners
  'Albania': [41.3275, 19.8187],
  'Belgium': [50.8503, 4.3517],
  'Bulgaria': [42.6977, 23.3219],
  'Canada': [45.4215, -75.6972], // Ottawa
  'Croatia': [45.8150, 15.9819],
  'Czech Republic': [50.0755, 14.4378],
  'Denmark': [55.6761, 12.5683],
  'Estonia': [59.4370, 24.7536],
  'Finland': [60.1699, 24.9384],
  'France': [48.8566, 2.3522],
  'Germany': [52.5200, 13.4050],
  'Greece': [37.9838, 23.7275],
  'Hungary': [47.4979, 19.0402],
  'Iceland': [64.1466, -21.9426],
  'Italy': [41.9028, 12.4964],
  'Latvia': [56.9496, 24.1052],
  'Lithuania': [54.6872, 25.2797],
  'Luxembourg': [49.6116, 6.1319],
  'Moldova': [47.0105, 28.8638],
  'Montenegro': [42.4304, 19.2594],
  'Netherlands': [52.3702, 4.8952],
  'North Macedonia': [41.9973, 21.4280],
  'Norway': [59.9139, 10.7522],
  'Poland': [52.2297, 21.0122],
  'Portugal': [38.7223, -9.1393],
  'Romania': [44.4268, 26.1025],
  'Slovakia': [48.1486, 17.1077],
  'Slovenia': [46.0569, 14.5058],
  'Spain': [40.4168, -3.7038],
  'Sweden': [59.3293, 18.0686],
  'Turkey': [39.9334, 32.8597],
  'Ukraine': [50.4501, 30.5234],
  'United Kingdom': [51.5074, -0.1278],
  'United States': [38.9072, -77.0369], // Washington DC
};

export function getNationCoordinates(nationName: string): [number, number] | null {
  return NATION_COORDINATES[nationName] || null;
}
